"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushRecoStripModalAtcClick = pushRecoStripModalAtcClick;
const pattern_library_modules_cart_1 = require("@saatva-bits/pattern-library.modules.cart");
function getVariant(item = {}) {
    const attributes = item.attributes || item.productAttributes;
    if (!attributes) {
        return '';
    }
    return (attributes
        .map((attribute) => {
        /** The 'Standard' part of the Queen size pillows is removed in service-cart-checkout.
         * Here it is added back to maintain consistency with the rest of the pages.
         */
        if ((0, pattern_library_modules_cart_1.isPillowSku)(item.productCode) && attribute.value.toLowerCase() === 'queen') {
            return 'Standard/Queen';
        }
        return attribute.value.replace('"', ''); // Remove quotes from the value
    })
        .join('/') || null);
}
const getItemName = (item) => {
    if (item.productCode === 'foundation') {
        return 'Foundation & Bunkie Board';
    }
    return item.genericName || item.name;
};
function getItemData(item) {
    const variant = getVariant(item);
    return {
        item_id: item.sku,
        item_name: getItemName(item),
        item_category: item.category,
        item_category2: item.subcategory,
        item_variant: variant,
        price: item.price
    };
}
function pushRecoStripModalAtcClick(item, position = null) {
    try {
        window.dataLayer.push({
            event: 'recoStripModalAtc',
            ...getItemData(item),
            position
        });
    }
    catch (error) {
        console.error(`[Analytics recoStripModalAtc]: ${error}`);
    }
}
//# sourceMappingURL=analytics.js.map